import { Link } from '@/components/Link';
import { RouteType } from '@/util/routeToPath';
import { ReactNode } from 'react';
import styles from './TabBar.module.scss';

type Props = {
  to: RouteType;
  children: ReactNode;
  active?: boolean;
} & React.HTMLAttributes<HTMLAnchorElement>;

export function Tab({ to, active, children }: Props) {
  return (
    <Link to={to} aria-current={active ? 'page' : undefined}>
      {children}
    </Link>
  );
}

export function TabBar({ children }: { children: ReactNode }) {
  return <nav className={styles.TabBar}>{children}</nav>;
}
